module.exports = __webpack_public_path__ + "960da964036a25ed82de9e3ddd5fe32a.svg";